import { ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'beam'

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(4),
  },
}))

export interface RedirectToExternalProps {
    showMessage?: boolean,
    url: string,
    title?: string,
}

export const RedirectToExternal = ({ url, title, showMessage = true }: RedirectToExternalProps): ReactElement => {
  const { t } = useTranslation()
  const classes = useStyles()
  useEffect(() => {
    window.location.assign(url)
  }, [url])

  if (!showMessage) {
    return <div className={classes.root}></div>
  }

  return <div className={classes.root}>{t('opening')} <a href={url}>{title || url}</a></div>
}
